import { useSelector } from 'react-redux';
import { getUpdateMarkers, getUser } from '@mssgme/store';

export function useUser() {
    return useSelector(getUser);
}

export function useUpdateMarker(marker) {
    const markers = useSelector(getUpdateMarkers);

    return !!(marker && markers.includes(marker));
}
